var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.66 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.33,0A25.5,25.5,0,1,0,50.66,25.5,25.42,25.42,0,0,0,25.33,0Zm5.89,18.61v.82h0v11a9.88,9.88,0,0,1-2.88,7,9.78,9.78,0,0,1-13.88,0,9.92,9.92,0,0,1,0-14,9.76,9.76,0,0,1,6.94-2.9h1.82v5.2H21.4a4.61,4.61,0,0,0-3.29,1.37,4.67,4.67,0,0,0-1.36,3.32,4.73,4.73,0,0,0,1.36,3.32,4.65,4.65,0,0,0,7.94-3.3V10.65h5.14l.26.48a12.45,12.45,0,0,0,3.22,3.95,8,8,0,0,0,3.5,1.61l.92.16-1,5-.88-.16a12,12,0,0,1-3-1,9.64,9.64,0,0,1-3-2.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.4e73eae2d79555900a9c0f335e2d7c4f.svg";
export { ForwardRef as ReactComponent };